import { IconProps } from '../types/icons'

export const RotatorIcon = ({ color = '#fff', ...props }: IconProps) => (
    <svg {...props} viewBox="0 0 17 25" xmlns="http://www.w3.org/2000/svg">
        <g
            fill="none"
            fillRule="evenodd"
            stroke={color}
            strokeLinecap="square"
            strokeWidth="3"
            transform="translate(2 2)"
        >
            <path d="M6.5 21.011v-5.863" />
            <ellipse cx="6.5" cy="6.352" rx="6.5" ry="6.352" />
        </g>
    </svg>
)

export const ScalerIcon = ({ color = '#fff', ...props }: IconProps) => (
    <svg {...props} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fill={color} fillRule="evenodd" d="M13.333 6.667H6.667v6.666H0V20h20V0h-6.667z" />
    </svg>
)
